export const SERVER_ROOT_DOMAIN = 'pzacademy.com';
export const USER_INFO = 'userInfo';
export const CLASS_DOMAIN = 'https://class.pzacademy.com';
export const WWW_DOMAIN = 'https://www.pzacademy.com';

export const READER_FILE_DOWNLOAD_API = '/reader/pdf/';
